import React, { FC } from 'react';
import { styled } from 'styled-components';
import { Button } from '../buttons';

export const PageSubtitle = styled.div`
    text-align: center;
    font-size: 16px;
    line-height: 26px;
    margin-top: 0;
    margin-bottom: 30px;
`;

export const PageFooterButtonsInnerContainer = styled.div<{ $fixed?: boolean }>`
    position: relative;
    width: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    ${(props) =>
        props.$fixed &&
        `
        padding: 15px 48px;
    `}
`;

export const SectionTitle = styled.h5`
    font-size: 16px;
    font-weight: 600;
    color: #000000;
`;

export const SectionSubTitle = styled.h5`
    font-size: 14px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 10px;
`;

export const H1 = styled.h1`
    color: ${(props) => props.theme.app.component.pageTitle.textColor};
    margin: 10px 0 20px 0;
    font-size: 18px;
`;

export const H2 = styled.h2`
    color: ${(props) => props.theme.app.component.pageTitle.textColor};
    margin: 10px 0 20px 0;
    font-size: 16px;
`;
export const H3 = styled.h3`
    color: ${(props) => props.theme.app.component.pageTitle.textColor};
    margin: 10px 0 20px 0;
    font-size: 16px;
`;

export const H4 = styled.h4`
    color: ${(props) => props.theme.app.component.pageTitle.textColor};
    margin: 10px 0 20px 0;
    font-size: 14px;
`;

export const H5 = styled.h5`
    color: ${(props) => props.theme.app.component.pageTitle.textColor};
    margin: 10px 0 20px 0;
    font-size: 12px;
`;
export const H6 = styled.h6`
    color: ${(props) => props.theme.app.component.pageTitle.textColor};
    margin: 10px 0 20px 0;
    font-size: 10px;
`;

export const P = styled.div`
    margin-bottom: 20px;
    line-height: 1.6;
`;

export const Caption = styled.span<{ $isError?: boolean }>`
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${(props) => (props.$isError ? '#DE1C22' : 'rgb(68, 90, 100)')};
    white-space: pre-wrap; /* Preserves line breaks (\n) and multiple spaces. */
`;

export const HeadButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const TitleAndButton = styled.div`
    position: sticky;
    top: ${(props) => (props.theme.additionalProperties?.isToolbarHidden ? `${101 - 55}px` : '101px')};
    z-index: 19;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 62px;

    ${HeadButtonContainer} {
        margin: 10px 10px 10px 0;
    }
`;
const PageFooterButtonsInnerLeftContainer = styled.div`
    width: 50%;
`;

const PageFooterButtonsInnerRightContainer = styled.div`
    width: 50%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;

    ${Button} {
        min-width: 150px;
    }
`;

export const PageFooterButtonsOuterContainer = styled.div<{ $fixed?: boolean; $hasSidebar?: boolean }>`
    margin-top: 40px;
    left: 50px;
    right: 50px;
    background-color: rgba(246, 248, 249, 80%);
    bottom: 0px;
    ${(props) => props.$hasSidebar && `margin-left: 305px;`}

    ${(props) =>
        props.$fixed &&
        `
        position: fixed;
        left: ${props.theme.additionalProperties?.isSidebarHidden ? '0' : '295px'};
        right: 0;
        z-index: 1;
    `}
`;

interface PageFooterButtonsProps {
    $fixed?: boolean;
    hasSidebar?: boolean;
    leftContainerContent?: React.ReactNode;
    children?: React.ReactNode;
}

export const PageFooterButtons: FC<PageFooterButtonsProps> = ({ $fixed: fixed = true, hasSidebar, leftContainerContent, children }) => {
    return (
        <PageFooterButtonsOuterContainer $fixed={fixed} $hasSidebar={hasSidebar}>
            <PageFooterButtonsInnerContainer $fixed={fixed}>
                <PageFooterButtonsInnerLeftContainer>{leftContainerContent}</PageFooterButtonsInnerLeftContainer>
                <PageFooterButtonsInnerRightContainer>{children}</PageFooterButtonsInnerRightContainer>
            </PageFooterButtonsInnerContainer>
        </PageFooterButtonsOuterContainer>
    );
};
